export default __webpack_public_path__ + "static/media/Lin.6943e019.png";